import type { EmailTemplate } from '@entities/product/api/product.contract'

export type EmailVariable = {
  token: string
  label: string
  sample: string
}

const firstNameSample = 'Maria'

export const emailVariables: ReadonlyArray<EmailVariable> = [
  { token: '{primeiro_nome}', label: 'Primeiro nome', sample: firstNameSample },
  { token: '{produto}', label: 'Produto', sample: 'seu produto' },
]

export type EmailPreviewContext = {
  productName: string
  supportEmail: string
  amountLabel?: string
}

export type EmailPreviewFact = {
  label: string
  value: string
}

export type EmailPreview = {
  subject: string
  title: string
  paragraphs: ReadonlyArray<string>
  facts: ReadonlyArray<EmailPreviewFact>
  supportEmail: string
  footerNote: string
}

const fallbackSubject = 'Compra confirmada'
const fallbackParagraph = 'Obrigado pela compra. O vendedor enviará as instruções de entrega.'

function replaceToken(text: string, token: string, value: string): string {
  return text.split(token).join(value)
}

export function resolveEmailVariables(text: string, context: EmailPreviewContext): string {
  let output = replaceToken(text, '{primeiro_nome}', firstNameSample)
  output = replaceToken(output, '{produto}', context.productName)
  output = replaceToken(output, '{link_acesso}', '')
  return output
}

export function toEmailParagraphs(raw: string): string[] {
  const normalized = raw
    .replace(/<\/(p|div|h[1-6]|li)>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
  return normalized
    .split(/\n{2,}/)
    .map((block) =>
      block
        .replace(/[ \t]+/g, ' ')
        .replace(/\s*\n\s*/g, ' ')
        .trim(),
    )
    .filter((block) => block.length > 0)
}

export function projectEmailPreview(
  template: EmailTemplate,
  context: EmailPreviewContext,
): EmailPreview {
  const subject = resolveEmailVariables(template.subject, context).trim() || fallbackSubject
  const paragraphs = toEmailParagraphs(resolveEmailVariables(template.html, context))
  const facts: EmailPreviewFact[] = [
    { label: 'Produto', value: context.productName },
    ...(context.amountLabel ? [{ label: 'Total cobrado', value: context.amountLabel }] : []),
    { label: 'Venda', value: 'sale_exemplo' },
  ]
  return {
    subject,
    title: 'Compra confirmada',
    paragraphs: paragraphs.length > 0 ? paragraphs : [fallbackParagraph],
    facts,
    supportEmail: context.supportEmail,
    footerNote: `Você recebeu este e-mail porque comprou ${context.productName} na VendePay.`,
  }
}
